import { getApp } from "firebase/app";
import { getFirestore, collection } from "firebase/firestore";

const app = getApp();

// =============================== BASE  ===============================  //

export const REF = {
  NAME: "draft",
  COLLECTIONS: {
    BAILIFF: "bailiff",
    DIALOG: "dialog",
  },
};

export const getRefs = () => {
  const firestore = getFirestore(app, REF.NAME);
  const CREF = {
    bailiff: collection(firestore, REF.COLLECTIONS.BAILIFF),
    dialog: collection(firestore, REF.COLLECTIONS.DIALOG),
  };
  return CREF;
};
